export abstract class CameraService {
  abstract isAvailable: boolean;
  abstract snap(): Promise<{ file: File }>;
  abstract browse(): Promise<{ file: File }>;
}
